'use strict';

import {
    appendXSelectedCompanyHeader,
    dropzoneExists,
    fnErrorMsg,
    fnToastrFormError,
    getSelectedCompany,
    printResponse,
    resetForm
} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnPaySlipUpload = function () {

    var formName = '#form-upload-pay-slip';
    var modalName = '#modal-upload-pay-slip';

    if (!element_exists(modalName)) return false;

    var btnUpload = '.btn-upload-pay-slip';
    var tableName = '#datatable-existing-payrolls';
    var modal = $(modalName);

    $(document).off('click', btnUpload);
    $(document).on('click', btnUpload, createUploadPaySlipForm);

    modal.off().on('hidden.bs.modal', function () {
        resetForm($(formName));
        $(tableName).DataTable().ajax.reload(null, false);
    });

    function createUploadPaySlipForm(e) {

        const rowData = $(tableName).DataTable().row($(this).parents('tr')).data();

        $.ajax({
            type: 'POST',
            contentType: 'application/json',
            data: rowData.payslip,
            url: '/salary/pay-slips/upload-form',
            success: function (response) {

                modal.find('.modal-data-container').html(response);
                createPaySlipDropzone(JSON.parse(rowData.payslip));
            },
            error: fnToastrFormError,
        });
    }

    function createPaySlipDropzone(rowData) {

        if (!dropzoneExists($(formName))) {

            var uploadUrl = '/salary/pay-slips/upload';
            var deleteUrl = '/salary/pay-slips/delete';

            Dropzone.autoDiscover = false;

            var lang = allLangFiles.dropzone;

            $(formName).dropzone({

                dictDefaultMessage: lang.dictDefaultMessage,
                dictFallbackMessage: lang.dictFallbackMessage,
                dictFallbackText: lang.dictFallbackText,
                dictFileTooBig: lang.dictFileTooBig,
                dictInvalidFileType: lang.dictInvalidFileType,
                dictResponseError: lang.dictResponseError,
                dictCancelUpload: lang.dictCancelUpload,
                dictCancelUploadConfirmation: lang.dictCancelUploadConfirmation,
                dictRemoveFile: lang.dictRemoveFile,
                dictMaxFilesExceeded: lang.dictMaxFilesExceeded,

                url: uploadUrl,
                parallelUploads: 1,
                addRemoveLinks: true,
                maxFiles: 1,

                init: function () {

                    var myDropzone = this;

                    this.on('sending', function (file, xhr, formData) {
                        appendXSelectedCompanyHeader(xhr);
                    });

                    this.on('error', function(file, response) {
                        if (response && !response.responseJSON && !response.message) {
                            toastr.error(response);
                        }else if(response && response.message){
                            toastr.error(response.message);
                        }
                    });

                    this.on('maxfilesreached', function () {
                        myDropzone.removeEventListeners();
                        console.log('max');
                    });

                    this.on("removedfile", function (file) {

                        console.log('removed');

                        myDropzone.setupEventListeners();

                        myDropzone.options.maxFiles = 1;

                        $.ajax({
                            type: 'POST',
                            url: deleteUrl,
                            data: {id: rowData.id},
                            success: function (response) {
                                printResponse(response);
                            },
                            error: fnToastrFormError,
                        });
                    });
                },
            });
        }
    }
};